import type { FieldValues } from 'react-hook-form';

import {
  Form as ChordsForm,
  type FormProps as ChordsFormProps,
} from '~/chords/Form';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export type FormProps<FormType extends FieldValues> = Omit<
  ChordsFormProps<FormType>,
  'dangerouslyOverrideClassName'
> & { className?: string };

export const Form = withClassNameHoc(ChordsForm) as <
  FormType extends FieldValues,
>(
  props: FormProps<FormType>,
) => React.ReactElement;
